import type { TypePolicies } from '@apollo/client';
import { uploaderConfigsMap } from './uploader-configs';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      uploaderConfig: (_, { variables }) => {
        return uploaderConfigsMap.get(variables?.key) || null;
      },
    },
  },
};
